<div class="wrapper-feedback-info">
    <div class="section-title row">
        <div class="section-btn">
            <button routerLink='/dashboard/e-ticketing-list' class="btn btn-back" [attr.aria-label]="'Back' | translate">
              <i class="fi-rr-arrow-alt-left"></i>
            </button>
        </div>
        <div>
            <div class="title" [attr.data-parent]="'Feedback' | translate">{{'Feedback Info' |translate}}</div>
        </div>
    </div>

    <div class="section-action">
        <!--<div>
            <img class="all-icon" src="../../../assets/icon/all.svg" alt="icon">
            <div ngbDropdown class="d-inline-block w-100">
                <button class="btn btn-outline-primary text-indent-40" id="dropdownBasic1" ngbDropdownToggle>All</button>
                <div ngbDropdownMenu aria-labelledby="dropdownBasic1" class="custom-dropdown">
                    <button ngbDropdownItem>Dropdown 1</button>
                    <button ngbDropdownItem>Dropdown Active</button>
                    <button ngbDropdownItem>Dropdown 2</button>
                    <button ngbDropdownItem>Dropdown 2</button>
                </div>
            </div>
        </div>
        <div class="form-group">
            <div  class="d-inline-block w-100">
                <button routerLink='/dashboard/feedback-form' class="btn btn-outline-primary" >Create Feedback</button>
            </div>
        </div>-->
    </div>

    <div class="section-main">

            <div class="row" >
              <div class="message-info col-6" *ngIf="feedbackForm">
                <div class="card h-2 mt-4">
                    <!--<h4 class="title">Company address</h4>
                    <p class="subtitle">
                        The physical address of your store or place of business. If you don't have a
                        business address, enter the address from which you ship orders.
                    </p>-->
                    <div class="row mt-3">
                        <div class="col-12 col-sm-12 col-md-12 col-lg-3">
                            <h4 class="title-2 mt-2">{{'Topic' |translate}}</h4>
                        </div>
                        <div class="col-12 col-sm-12 col-md-12 col-lg-9">
                            <div class="form-group">
                              <p class="subtitle">
                                {{ '{0}' | translate:[ utils.translate(feedbackForm?.topic_info?.topic)] }}
                              </p>
                            </div>
                        </div>
                    </div>
                    <div class="row mt-3">
                        <div class="col-12 col-sm-12 col-md-12 col-lg-3">
                            <h4 class="title-2 mt-2">{{'Message' |translate}}</h4>
                        </div>
                        <div class="col-12 col-sm-12 col-md-12 col-lg-9">
                            <div class="form-group">
                              <p class="subtitle">
                                  {{feedbackForm?.message}}
                              </p>
                            </div>
                        </div>
                    </div>
                    <div class="row mt-3">
                        <div class="col-12 col-sm-12 col-md-12 col-lg-3">
                            <h4 class="title-2 mt-2">{{'Photo' |translate}}</h4>
                        </div>
                        <div class="col-12 col-sm-12 col-md-12 col-lg-9">
                            <div class="form-group">
                              <!-- <p class="subtitle">
                                  {{feedbackForm?.photo}}
                              </p> -->
                              <img height="200px" src="{{feedbackForm?.photo}}" alt="">
                            </div>
                        </div>
                    </div>
                    <div class="row mt-3">
                        <div class="col-12 col-sm-12 col-md-12 col-lg-3">
                            <h4 class="title-2 mt-2">{{'Date Created' |translate}} </h4>
                        </div>
                        <div class="col-12 col-sm-12 col-md-12 col-lg-9">
                            <div class="form-group">
                              <p class="subtitle">
                                  {{feedbackForm?.created_at | date:'medium'}}
                              </p>
                            </div>
                        </div>
                    </div>
                </div>
              </div>
            </div>

    </div>
</div>
